var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateParcel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digital",
    clipPath: "url(#clip0_1784_6786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#0061AF",
    d: "M35.054 79.533c19.084 0 34.554-8.523 34.554-19.038 0-10.514-15.47-19.038-34.554-19.038C15.971 41.457.5 49.981.5 60.495c0 10.515 15.47 19.038 34.554 19.038Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5.698 59.281-1.394-.956c-.436-.348-.697-.782-.697-1.39l.348-27.122c0-1.999 1.133-3.911 2.875-4.867L47.778 1.389c.871-.521 1.917-.521 2.788-.087l1.045.522"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m5.698 59.281-1.394-.956c-.436-.348-.697-.782-.697-1.39l.348-27.122c0-1.999 1.133-3.911 2.875-4.867L47.778 1.389c.871-.521 1.917-.521 2.788-.087l1.045.522"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#fff",
    d: "M7.179 61.367v1.826c0 .956.523 1.738 1.307 2.26L29.83 78.057a7.643 7.643 0 0 0 7.928 0l39.815-23.122c.871-.522 1.394-1.39 1.306-2.434l-.087-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.179 61.367v1.826c0 .956.523 1.738 1.307 2.26L29.83 78.057a7.643 7.643 0 0 0 7.928 0l39.815-23.122c.871-.522 1.394-1.39 1.306-2.434l-.087-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0061AF",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M7.179 61.367v1.826c0 .956.523 1.738 1.307 2.26L29.83 78.057a7.643 7.643 0 0 0 7.928 0l39.815-23.122c.871-.522 1.394-1.39 1.306-2.434l-.087-2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fill: "#fff",
    stroke: "#0061AF",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m4.914 57.803.174-27.468c0-1.825 1.046-3.564 2.614-4.52L49.695 1.65c1.132-.695 2.613.174 2.613 1.565l-.348 27.642c0 1.825-1.046 3.564-2.614 4.433L7.527 59.281c-1.22.696-2.7-.087-2.613-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fill: "#fff",
    stroke: "#0061AF",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M30.876 76.406 7.615 62.15a.892.892 0 0 1 0-1.478l42.428-24.339a6.334 6.334 0 0 1 6.099 0L77.4 48.503a2.608 2.608 0 0 1 0 4.52l-40.25 23.47c-1.917 1.13-4.357 1.043-6.274-.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m45.426 41.549 2.352-1.391 2.527 1.39-2.527 1.478-2.352-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fill: "#fff",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m49.347 39.288 2.352-1.477 2.527 1.39-2.44 1.565-2.44-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m41.419 43.895 2.352-1.477 2.527 1.39-2.527 1.565-2.352-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m37.41 46.33 2.353-1.478 2.526 1.39-2.526 1.565-2.352-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m33.229 48.676 2.352-1.39 2.527 1.39-2.44 1.478-2.439-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m29.134 51.023 2.352-1.39 2.527 1.39-2.44 1.478-2.44-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m25.213 53.283 2.353-1.477 2.526 1.39-2.44 1.565-2.439-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.778 44.852 2.353-1.478 2.526 1.39-2.526 1.478-2.353-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m52.831 46.503 2.353-1.39 2.526 1.39-2.526 1.478-2.352-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m55.27 49.806 2.353-1.39 2.526 1.39-2.44 1.478-2.439-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m56.403 53.718 4.269-2.434 2.614 1.478-4.444 2.434-2.44-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m61.979 50.589 5.837-3.303 2.614 1.303-6.099 3.477-2.352-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m51.524 51.98 2.353-1.391 2.526 1.39-2.44 1.478-2.439-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.778 54.24 2.353-1.478 2.526 1.478-2.526 1.477-2.353-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m43.77 56.413 2.353-1.478 2.526 1.39-2.44 1.566-2.439-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m40.024 58.673 2.353-1.478 2.526 1.39-2.526 1.566-2.353-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m36.191 60.846 2.353-1.39 2.526 1.39-2.44 1.478-2.439-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m32.444 63.019 2.353-1.478 2.613 1.391-2.526 1.565-2.44-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m35.232 66.148 4.27-2.52 2.787 1.303-4.617 2.695-2.44-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M40.983 62.584 55.01 54.5l2.526 1.565-14.114 8.084-2.44-1.565Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m46.123 64.41 11.239-6.52 4.095 2.26-11.24 6.694-4.094-2.434Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m49.085 48.676 2.353-1.39 2.526 1.39-2.44 1.478-2.439-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m45.426 50.85 2.352-1.391 2.527 1.39-2.527 1.478-2.352-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m41.592 53.023 2.353-1.391 2.526 1.39-2.526 1.478-2.353-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m37.76 55.37 2.352-1.391 2.526 1.39-2.44 1.478-2.439-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m33.839 57.63 2.352-1.478 2.527 1.39-2.44 1.478-2.44-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m30.005 59.716 2.352-1.391 2.527 1.39-2.44 1.478-2.44-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m26.346 61.889 2.352-1.39 2.527 1.39-2.44 1.478-2.44-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m19.55 65.888 5.14-3.043 2.527 1.391-5.053 3.13-2.614-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m23.732 68.234 7.144-4.433 2.875 1.652-7.405 4.346-2.614-1.565Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m27.217 70.582 6.535-3.825 2.874 1.651-6.534 3.999-2.875-1.825Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m51.524 42.592 4.444-2.608 2.44 1.478-4.444 2.52-2.44-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m43.77 47.112 2.353-1.391 2.526 1.39-2.44 1.478-2.439-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m40.024 49.459 2.353-1.478 2.526 1.39-2.526 1.478-2.353-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m36.278 51.545 2.353-1.39 2.613 1.39-2.526 1.477-2.44-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M32.096 53.892 34.45 52.5l2.526 1.39-2.526 1.479-2.353-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m28.35 56.152 2.352-1.39 2.527 1.39-2.44 1.478-2.439-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m24.517 58.151 2.352-1.478 2.526 1.391-2.526 1.478-2.352-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m15.456 63.714 7.492-4.433 2.527 1.391-7.493 4.433-2.526-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m21.206 55.63 2.352-1.39 2.527 1.39-2.527 1.478-2.352-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m17.111 58.151 2.353-1.478 2.526 1.391-2.44 1.478-2.439-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m11.448 61.194 2.353-1.478 2.526 1.39-2.44 1.565-2.439-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m61.544 49.372-3.05-1.739 1.569-1.043-3.834-2.173 3.921-2 6.883 3.738-5.49 3.217Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    fill: "#fff",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M30.51 40.09c9.296 0 16.83-7.482 16.83-16.711 0-9.23-7.535-16.712-16.83-16.712-9.294 0-16.828 7.482-16.828 16.712S21.216 40.09 30.51 40.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    fill: "#0061AF",
    d: "M37.15 18.689a.156.156 0 0 0 .077-.136.156.156 0 0 0-.076-.136l-5.86-3.486a2.417 2.417 0 0 0-2.468 0l-5.86 3.486a.155.155 0 0 0-.075.136.16.16 0 0 0 .076.136l7.016 4.226a.151.151 0 0 0 .156 0l7.015-4.226Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    fill: "#0061AF",
    d: "M22.307 19.758a.152.152 0 0 0-.21.058.158.158 0 0 0-.02.079v6.83c0 .33.085.653.246.938.16.286.391.523.669.689l6.221 3.819a.15.15 0 0 0 .21-.057.16.16 0 0 0 .02-.079V24.11a.16.16 0 0 0-.076-.136l-7.06-4.216Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    fill: "#0061AF",
    d: "M30.67 24.137v7.896a.16.16 0 0 0 .078.136.15.15 0 0 0 .153 0l6.221-3.82c.278-.165.508-.402.669-.687.16-.285.245-.608.246-.936v-6.831a.16.16 0 0 0-.077-.136.15.15 0 0 0-.153 0l-7.06 4.243a.156.156 0 0 0-.076.135Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1784_6786"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateParcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/create-parcel.72c29b37ddc3e352304d8a12091c04ad.svg";